import React from 'react';
import PropTypes from 'prop-types';

const Refresh = ({
  className = '',
  color = '#ffff',
  height = '24px',
  width = '24px',
}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 1792 1792"
  >
    <path
      fill={color}
      d="M893 189.8C727.6 188 561.7 248 436.8 357.3c-93.2 82-166 187.4-206.7 305-5 14.2-9 28.7-13 43.3 46.6-.3 93.3 2.3 139.8-.6 32.4-84.2 77.4-165.8 145-227 134-126.2 330.7-183.7 511-145 114.8 23.7 222.5 82.8 301.7 169.3 10.8 15.7 3.8 38.4-11.3 48.6-49.5 52-104.5 99-151 154 6.6 2.7 13.6-1 20.5.2 143-1 286.2 3 429-2 4.3-9-.4-19 1-28.3-1-73.8 0-147.7 0-221.5.2-66.4 0-133-2.3-199-6 2.5-8.2 9.3-13.4 12.8-54.2 53-107.7 107-162 160-133-149-331.2-238.8-531.2-238zm-269.3 895.7c-144 3.2-288-3.2-431.7 3-4.5.3-2.5 6.5-3 9.6 2 21 .6 42 1.2 62.8.7 125.6-3.2 251.3 2.5 376.7 5.8-3.2 8.7-10 14.2-14 53-53 106-106.4 160-159.4 155 180 406.3 269.3 640.2 230.3 194-29 371.4-148 474.6-315 38-59.3 67-124.6 85.4-193-44 .8-88-1-131.8.7-31.2 79-71.5 156.5-133.7 216-125.6 125.3-311.8 189.2-488 161.4-119-17.7-233.3-72.4-317.4-159-18.6-24-12.4-60.2 8.5-80.4 44-47.2 94.8-88 134.6-138.7-5-1.7-11 0-16.3-.4z"
    />
  </svg>
);

Refresh.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};

export default Refresh;
